// React hooks
import { useState, useEffect } from 'react';
// Redux for state
import { useSelector } from 'react-redux';
// View-only profile display
import ProfileCard from './ProfileCard';
// Edit mode for own profile
import ProfileEditor from './ProfileEditor';

// Own profile with edit toggle
function ProfileSelf() {
  const ownProfile = useSelector((s) => s.user.profile);

  // Edit mode state
  const [editing, setEditing] = useState(false);
  const firstTimeViews = ownProfile?.first_time_views || {};
  const isFirstTime = !firstTimeViews.profile_welcome;

  // Auto-enter edit mode on first-time setup
  useEffect(() => {
    if (isFirstTime) setEditing(true);
  }, [isFirstTime]);

  // Loading state
  if (!ownProfile) {
    return <div className="p-6 text-center text-sm text-muted-foreground">Loading profile...</div>;
  }

  // Show editor when editing
  if (editing) {
    return <ProfileEditor user={ownProfile} onSave={() => setEditing(false)} onCancel={() => setEditing(false)} />;
  }

  // Show view mode with edit button (only for non-first-time users)
  return (
    <div className="relative h-full overflow-y-auto">
      <ProfileCard profileData={ownProfile} />

      {/* Edit button - only show if not first time */}
      {!isFirstTime && (
        <button
          onClick={() => setEditing(true)}
          className="profileSelf fixed bottom-2.5 right-4 z-30 flex items-center gap-2 rounded-full bg-primary/80 px-5 py-3 text-sm font-medium text-primary-foreground shadow-lg blur-window"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
          Edit
        </button>
      )}
    </div>
  );
}

export default ProfileSelf;
